import { ReactSVG } from "react-svg";
import { Typography } from "@/components/Typography";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";
import { ContactErrorModalProps, ContactSuccessModalProps } from "./types";
import { ModalProps } from "@/contexts/ModalContext/types";
import "./styles.scss";

export const getContactSuccessModal = (props: ModalProps<ContactSuccessModalProps>) => {
  const { data, onConfirmButton } = props;

  return (
    <div className="contact-us__success-modal">
      <ReactSVG
        className="u-spacing-5"
        data-testid="confirm-img"
        src={data.SuccessModal.image}
      />

      {data.SuccessModal.richtext.map((item, i) => {
        return (
          <Typography
            key={i}
            {...item}
            Tag={item.tag}>
            {item.content}
          </Typography>
        );
      })}

      <ButtonLib
        id={data.SuccessModal.button.id}
        variant="secondary"
        onClick={onConfirmButton}
        dataQA={data.SuccessModal.button.data_qa}
        label={data.SuccessModal.button.label}
      />
    </div>
  );
};

export const getContactErrorModal = (props: ModalProps<ContactErrorModalProps>) => {
  const { data, onConfirmButton } = props;

  return (
    <div className="contact-us__error-modal">
      <ReactSVG
        className="u-spacing-5"
        data-testid="confirm-img"
        src={data.ErrorModal.image}
      />

      {data.ErrorModal.richtext.map((item, i) => {
        return (
          <Typography
            key={i}
            {...item}
            Tag={item.tag}>
            {item.content}
          </Typography>
        );
      })}

      <ButtonLib
        id={data.ErrorModal.button.id}
        variant="secondary"
        onClick={onConfirmButton}
        dataQA={data.ErrorModal.button.data_qa}
        label={data.ErrorModal.button.label}
      />
    </div>
  );
};
